<template>
  <div
    class="m-partner new top-nav"
    id="partner"
    v-if="
      extras.groupPartnerDisplay &&
      extras.groupPartnerDisplay.display == 1 &&
      columns.length > 0
    "
    :style="{
      background:
        extras.partnerBg.colorOrBg == 'color'
          ? extras.partnerBg.color
          : 'url(' + extras.partnerBg.src + ')',
    }"
  >
    <WapTitle
      v-if="extras.partnerTitle.display == 1"
      :title="extras.partnerTitle.mainTitle || title"
      :en="extras.partnerTitle.subTitle || 'MEDIA'"
      :extras="extras"
    />
    <div class="wap-schedule-outer">
      <div
        class="m-tab-list-new-wap"
        :class="'tab-length' + columns.length"
        v-if="columns.length > 1 || (columns.length == 1 && columns[0].id != 0)"
      >
        <div
          class="tab-new"
          v-for="(item, index) in columns"
          :key="index"
          :class="{
            active: index == currentId,
          }"
          @click="columnClick(item, index)"
        >
          {{ item.name }}
          <div data-v-2a8f24dd="" class="underline"></div>
        </div>
      </div>
    </div>

    <div class="g-partner-list-new-wap">
      <div
        class="item"
        v-for="(item, i) in articles"
        :key="i"
        @click="detailClick(item)"
      >
        <img
          :src="
            item.coverImageRealPath
              ? item.coverImageRealPath
              : require('@/assets/images/defPartner.png')
          "
        />
      </div>
    </div>

    <div class="no-data" v-if="articles.length == 0">
      <img :src="require('@/assets/images/nodata.png')" />
      <div class="no-data-text">暂无数据</div>
    </div>
  </div>
</template>

<script>
import WapTitle from "./Title.vue";
import { URLS } from "fire-wind-water";

export default {
  components: {
    WapTitle,
  },
  props: {
    partnerInfo: [],
    extras: Object,
  },
  data() {
    return {
      num: 0,
      title: "合作伙伴",
      icon: require("@/assets/images/wap/huoban.png"),
      columns: [],
      articles: [],
      currentId: 0,
      isShowMore: false,
    };
  },
  created() {
    console.log("wap-partner", this.partnerInfo);
  },
  computed: {
    // columns: function () {
    //   let tempArticles = this.partnerInfo.article;
    //   let tempColumns = this.partnerInfo.column;
    //   const columns = [
    //     {
    //       id: 0,
    //       name: "合作伙伴",
    //       article: tempArticles,
    //     },
    //   ];
    //   for (let item in tempArticles) {
    //     if (item.desc) {
    //       item.desc = item.desc.substr(0, 130);
    //     }
    //   }
    //   for (let i in tempColumns) {
    //     columns.push(tempColumns[i]);
    //   }
    //   return columns;
    // },
    // articles() {
    //   return this.columns[this.currentId].article;
    // },
  },
  mounted() {
    console.log("pc-partner", this.partnerInfo);
    //this.initColumns();

    let tempColumns = this.getColumns.articleInitColumns(
      this.partnerInfo.column,
      this.partnerInfo.article,
      "合作伙伴",
      true
    );
    this.columns = tempColumns;

    this.articles = this.columns[0] ? this.columns[0].article : [];
  },
  methods: {
    columnClick(item, idx) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.currentId = idx;
      this.articles = item.article;
    },
    ClickDetll(url) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      window.$sk.goto(url, true).subscribe((url) => {
        window.open(url);
      });
    },
    detailClick(e) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      if (this.extras.partnerStyle.style == "none") {
        return;
      }
      console.log("e", e);
      this.$emit("partnerDetailClick", e);
    },
    showMoreArticle() {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.isShowMore = !this.isShowMore;
    },
  },
};
</script>
<style lang="scss" scoped></style>
